import { render, staticRenderFns } from "./HomeTabsSugal.vue?vue&type=template&id=06a8de9a&scoped=true&"
import script from "./HomeTabsSugal.vue?vue&type=script&lang=ts&"
export * from "./HomeTabsSugal.vue?vue&type=script&lang=ts&"
import style0 from "./HomeTabsSugal.vue?vue&type=style&index=0&id=06a8de9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a8de9a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('06a8de9a', component.options)
    } else {
      api.reload('06a8de9a', component.options)
    }
    module.hot.accept("./HomeTabsSugal.vue?vue&type=template&id=06a8de9a&scoped=true&", function () {
      api.rerender('06a8de9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/HomeTabsSugal.vue"
export default component.exports